import { IPaginatedList } from 'components/Pagination/constans';
import {
  SearchCombinator,
  SearchConstraintDTO,
  SearchConstraintRootDTO,
  SearchTargetDTO,
  WellIngDTO,
} from 'business/models/Models';
import { getModelArray } from './utils';
import { RuleGroupType } from 'react-querybuilder';
import { cloneDeep } from 'lodash';
import {
  getDropVolHTMl,
  getProteinIngHTML,
  getStandardIngHtml,
  getWellInfoHtml,
} from 'components/commandpanel/IngredientInfo/IngredientInfo';
import { Props as IIngredientWellInfoProps } from 'components/commandpanel/IngredientInfo/IngredientWellInfo';
import { getProteinInfo } from 'components/sidePanel/searchAndFilter/utils';
import { GetSeedName } from 'utils/Global';
import { SeedInfo } from 'business/models/Layer';
import { IIngredientProteinInfo } from 'components/commandpanel/IngredientInfo/IngredientProteinInfo';

export const transformSearchTargets = (
  searchTargets: SearchTargetDTO[],
): SearchTargetDTO[] => {
  return searchTargets.map((i) => i.toJSON());
};

export const transformWellIngredients = (
  wells: WellIngDTO[],
): IPaginatedList<WellIngDTO> => {
  const _wells = wells.map((i) => i.toJSON());
  return transformPagination<WellIngDTO>(_wells, _wells.length);
};

export function transformPagination<T>(
  data: T[],
  total = 0,
  perPage = 1000,
  page = 1,
): IPaginatedList<T> {
  return {
    items: data,
    pagination: { page, perPage, total },
  };
}

export const getSearchConstraintModel = (
  constraints: RuleGroupType,
): SearchConstraintRootDTO => {
  const constraintsModel: SearchConstraintRootDTO = new SearchConstraintRootDTO();
  constraintsModel.rules = getRulesModelArray(cloneDeep(constraints.rules));
  constraintsModel.combinator = constraints.combinator as SearchCombinator;
  constraintsModel.not = constraints.not;
  return constraintsModel;
};

export const getRulesModelArray = (rules) => {
  rules.forEach((r) => {
    if (r.rules) {
      r.rules = getRulesModelArray(r.rules);
    }
  });
  return getModelArray(rules, SearchConstraintDTO);
};

export const transformIIngredientWellInfoProps = (
  wellName,
  isScreenRoute,
  dropVolumes,
  wellLayerIngs,
  wellVolumes,
): IIngredientWellInfoProps => {
  const { wellVolume, wellWaterVolume } = wellVolumes;
  return {
    wellName: wellName,
    isScreenRoute: isScreenRoute,
    dropVol: getDropVolHTMl(dropVolumes),
    wellInfoHTML: getWellInfoHtml(wellLayerIngs),
    wellVolume: wellVolume,
    wellWaterVolume: wellWaterVolume,
  } as IIngredientWellInfoProps;
};

export const transformIIngredientProteinInfo = (
  isScreenRoute,
  pfInfo,
  dropsData,
  seedId,
): IIngredientProteinInfo => {
  return {
    isScreenRoute: false,
    proteinInfo: getProteinInfo(pfInfo, dropsData),
    seedInfo: { seedName: GetSeedName(seedId) } as SeedInfo,
    well: {},
    proteinIngredientsHTML: getProteinIngHTML(pfInfo?.pfIng),
    standardIngredientHTML: getStandardIngHtml(pfInfo?.pfStIng),
  } as IIngredientProteinInfo;
};
